import React from 'react';
var AccordionContext = /*#__PURE__*/React.createContext({
  level: 0
});
export default AccordionContext;